import { Building2, TrendingUp, TrendingDown, Home, MapPin, BarChart3, Calendar, DollarSign, Percent, ArrowRight, ArrowDown, ArrowUp, Info, AlertCircle, CheckCircle2, XCircle, HelpCircle, Landmark, Wallet, Calculator, Scale, Banknote, RotateCcw } from 'lucide-react';

// 引用數據
export const citations = {
  1: {
    title: "廣州安居客房價網",
    url: "https://mobile.anjuke.com/fangjia/guangzhou2024/fangcun/",
    content: "芳村2024年12月二手房均價為31,512元/平方米。",
    date: "2024年12月",
    siteName: "安居客",
    sourceContent: "芳村2024年12月二手房均價 31512元/平方米。數據來源於安居客。"
  },
  2: {
    title: "廣州荔灣區芳村2025年02月新房房價",
    url: "https://mobile.anjuke.com/xf/fj-gz/liwan-233/2025/02/",
    content: "芳村2025年02月新房樓盤平均單價：56480.40元/平方米",
    date: "2025年2月",
    siteName: "安居客",
    sourceContent: "芳村2025年02月新房房價數據 房價數據由安居客綜合計算所得，供您參考！ 芳村2025年02月新房樓盤 平均單價：_56480.40_元/平方米"
  },
  3: {
    title: "商舖供求波動起伏大,產業項目助力復甦",
    url: "https://gz.focus.cn/zixun/78018ec8b24b3e8a.html",
    content: "2020年廣州商舖市場供應量重回40萬平方米，入市6612套48.7萬平方米，供應量較去年的歷史低位倍增，漲幅達103%。市場成交5022套50.7萬平方米，成交量同比大跌41%",
    date: "2020年",
    siteName: "廣州搜狐焦點",
    sourceContent: "2020年廣州商舖市場供應量重回40萬平方米，入市6612套48.7萬平方米，供應量較去年的歷史低位倍增，漲幅達103%。市場成交5022套50.7萬平方米，成交量同比大跌41%。廣州商舖市場成交大幅下滑，一是因為實體店受新冠疫情衝擊明顯，短期內對商舖投資信心有一定的影響；二是由於去年廣州商舖市場成交創歷史新高，與2020年疫情下的交投氛圍形成較大的落差。"
  },
  4: {
    title: "廣州市統計局 - 個體經營戶主要資料",
    url: "http://tjj.gz.gov.cn/stats_newtjyw/tjsj/pcsj/d1cjjpc/content/post_2787867.html",
    content: "芳村區個體經營戶數12329戶，營業收入43.63億元，經營面積74.3萬平方米",
    date: "2009年",
    siteName: "廣州市統計局",
    sourceContent: "芳村區 12329 43.63 37.35 1.32 74.3 3.43 1.65 3.08 1.56 2.02"
  },
  5: {
    title: "芳村花園二手房房價走勢",
    url: "https://mobile.anjuke.com/esf/gz-cm111203/",
    content: "小區附近有個大的肉菜市場，買菜還是比較方便，每天早上都有好多人在買菜，附近還有一些錢大媽，番薯藤等等買菜的地方，買菜是比較方便的，還有一些早餐店，吃早餐也方便。",
    date: "2024年",
    siteName: "安居客",
    sourceContent: "小區附近有個大的肉菜市場，買菜還是比較方便，每天早上都有好多人在買菜，附近還有一些錢大媽，番薯藤等等買菜的地方，買菜是比較方便的，還有一些早餐店，吃早餐也方便。"
  },
  6: {
    title: "廣州安居客2023房價網",
    url: "https://mobile.anjuke.com/fangjia/guangzhou2023/fangcun/",
    content: "芳村2023年12月二手房均價為31,806元/平方米。",
    date: "2023年12月",
    siteName: "安居客",
    sourceContent: "芳村2023年12月二手房均價 31806元/平方米。數據來源於安居客。"
  },
  7: {
    title: "2020年廣州商舖市場報告摘要",
    url: "https://www.sohu.com/a/443827228_120062651",
    content: "2020年廣州商舖市場供應48.7萬平方米，成交50.7萬平方米。",
    date: "2020年",
    siteName: "搜狐網",
    sourceContent: "2020年廣州商舖市場供應量重回40萬平方米，入市6,612套48.7萬平方米...市场成交5,022套50.7万平方米..."
  },
  8: {
    title: "2021年廣州零售商業市場年報",
    url: "https://www.winshang.com/news/649510.html",
    content: "2021年廣州商舖市場供應約40.3萬平方米，成交約40.5萬平方米。",
    date: "2021年",
    siteName: "贏商網",
    sourceContent: "2021年優質零售物業市場新增供應約40.3萬平方米...全年淨吸納量錄得約40.5萬平方米..."
  },
  9: {
    title: "2022年廣州房地產市場回顧與展望",
    url: "https://www.savills.com.cn/research-and-finance/research-and-news/article/334095/2023-02-02/-2022nianguangzhoufangdichanshichanghuigujiwang-zihao--da--zhong--xiao.aspx",
    content: "2022年廣州零售物業市場新增供應105萬平方米，全年淨吸納量錄得60萬平方米。",
    date: "2022年",
    siteName: "Savills 第一太平戴維斯",
    sourceContent: "全市新增供應105萬平方米...全年淨吸納量錄得60萬平方米..."
  },
  10: {
    title: "2023年廣州房地產市場總結與2024年展望",
    url: "https://news.winshang.com/html/067/9518.html",
    content: "2023年廣州零售物業市場新增供應約65.7萬平方米，全市淨吸納量約55.6萬平方米。",
    date: "2023年",
    siteName: "贏商網",
    sourceContent: "全年廣州零售市場新增供應約65.7萬平方米...全市淨吸納量約55.6萬平方米..."
  },
  11: {
    title: "2024年廣州商業地產市場展望",
    url: "https://www.sharerw.com/hangye/shangye/2024-01-25/10609.html",
    content: "預計2024年廣州零售物業市場將迎來約70萬平方米的新增供應。",
    date: "2024年 (預測)",
    siteName: "觀點網",
    sourceContent: "2024年，廣州零售市場預計有70萬平方米的新增供應入市..."
  }
};

// 歷史房價數據（估算）
export const historicalPriceData = [
  { year: 2010, price: 15000, commercialPrice: 18000, rentalPrice: 1200 },
  { year: 2011, price: 16500, commercialPrice: 19800, rentalPrice: 1300 },
  { year: 2012, price: 18200, commercialPrice: 21800, rentalPrice: 1400 },
  { year: 2013, price: 20000, commercialPrice: 24000, rentalPrice: 1500 },
  { year: 2014, price: 22000, commercialPrice: 26400, rentalPrice: 1600 },
  { year: 2015, price: 24000, commercialPrice: 28800, rentalPrice: 1700 },
  { year: 2016, price: 26500, commercialPrice: 31800, rentalPrice: 1800 },
  { year: 2017, price: 28000, commercialPrice: 33600, rentalPrice: 1850 },
  { year: 2018, price: 29500, commercialPrice: 35400, rentalPrice: 1900 },
  { year: 2019, price: 31000, commercialPrice: 37200, rentalPrice: 1950 },
  { year: 2020, price: 30500, commercialPrice: 36600, rentalPrice: 1900 },
  { year: 2021, price: 31500, commercialPrice: 37800, rentalPrice: 2000 },
  { year: 2022, price: 32000, commercialPrice: 38400, rentalPrice: 2050 },
  { year: 2023, price: 32500, commercialPrice: 39000, rentalPrice: 2100 },
  { year: 2024, price: 31500, commercialPrice: 37800, rentalPrice: 2100 },
  { year: 2025, price: 31000, commercialPrice: 37200, rentalPrice: 2050 }
];

// 交易量數據（估算）
export const transactionVolumeData = [
  { year: 2010, sales: 1200, rentals: 3500 },
  { year: 2011, sales: 1350, rentals: 3800 },
  { year: 2012, sales: 1500, rentals: 4200 },
  { year: 2013, sales: 1650, rentals: 4600 },
  { year: 2014, sales: 1800, rentals: 5000 },
  { year: 2015, sales: 1950, rentals: 5400 },
  { year: 2016, sales: 2100, rentals: 5800 },
  { year: 2017, sales: 2250, rentals: 6200 },
  { year: 2018, sales: 2400, rentals: 6600 },
  { year: 2019, sales: 2550, rentals: 7000 },
  { year: 2020, sales: 1500, rentals: 6500 },
  { year: 2021, sales: 1800, rentals: 7200 },
  { year: 2022, sales: 1650, rentals: 7500 },
  { year: 2023, sales: 1500, rentals: 7800 },
  { year: 2024, sales: 1350, rentals: 8000 },
  { year: 2025, sales: 1200, rentals: 8200 }
];

// 投資回報率數據
export const roiData = [
  { year: 2010, rental: 8.0, appreciation: 10.0, total: 18.0 },
  { year: 2011, rental: 7.9, appreciation: 9.5, total: 17.4 },
  { year: 2012, rental: 7.7, appreciation: 9.0, total: 16.7 },
  { year: 2013, rental: 7.5, appreciation: 8.5, total: 16.0 },
  { year: 2014, rental: 7.3, appreciation: 8.0, total: 15.3 },
  { year: 2015, rental: 7.1, appreciation: 7.5, total: 14.6 },
  { year: 2016, rental: 6.8, appreciation: 7.0, total: 13.8 },
  { year: 2017, rental: 6.6, appreciation: 6.5, total: 13.1 },
  { year: 2018, rental: 6.4, appreciation: 6.0, total: 12.4 },
  { year: 2019, rental: 6.3, appreciation: 5.5, total: 11.8 },
  { year: 2020, rental: 6.2, appreciation: -1.0, total: 5.2 },
  { year: 2021, rental: 6.3, appreciation: 3.0, total: 9.3 },
  { year: 2022, rental: 6.4, appreciation: 1.5, total: 7.9 },
  { year: 2023, rental: 6.5, appreciation: 1.0, total: 7.5 },
  { year: 2024, rental: 6.7, appreciation: -3.0, total: 3.7 },
  { year: 2025, rental: 6.6, appreciation: -1.5, total: 5.1 }
];

// 區域對比數據
export const districtComparisonData = [
  { name: '芳村', price: 37800, rental: 2100 / 37.5, roi: 6.6 },
  { name: '荔灣其他', price: 39500, rental: 2200 / 37.5, roi: 6.7 },
  { name: '越秀', price: 45000, rental: 2500 / 37.5, roi: 6.7 },
  { name: '海珠', price: 42000, rental: 2300 / 37.5, roi: 6.6 },
  { name: '天河', price: 48000, rental: 2700 / 37.5, roi: 6.8 }
];

// 商舖類型對比數據
export const shopTypeComparisonData = [
  { name: '小區內商舖', price: 35000, rental: 2000, roi: 6.9 },
  { name: '臨街商舖', price: 42000, rental: 2500, roi: 7.1 },
  { name: '商場內商舖', price: 48000, rental: 2800, roi: 7.0 },
  { name: '寫字樓底商', price: 45000, rental: 2600, roi: 6.9 }
];

// 投資決策分析數據
export const investmentDecisionData = [
  { name: '出售', value: 60 },
  { name: '繼續出租', value: 40 }
];

// Illustrative sample data for rental market comparison graph based on May 2025 web search of Anjuke Fangcun listings
export const rentalMarketSampleData = [
  { size: 50, rent: 6000, name: '市場掛牌: 東漖市場 (50平方米)', url: 'https://m.anjuke.com/gz/sp/zu/7065874452/?proType=zhiding&legoHuiDu=0&houseid=3941261548724238&zhidingLegoTid=6a6a222b-ba24-45a4-93c2-b85c0164db47&zhidingLegoHuiDu=1&zhidingLegoAdClickUrl=aHR0cHM6Ly9sZWdvLWNsaWNrLmFuanVrZS5jb20vanVtcD90YXJnZXQ9cFp3WTBabmxzenFHc2hZOG12cVZUeUVWUEFOem55RldtdkVWUDFSQm1pWVl1QW1rc0hiMW5qRVZuQW1ZbnlGQnJBRUxtaDdiVEhEa25ITllQajAzclRES24xYlluSGN2bkhOWXJqMHpQamMxclREa1RIRGtuVERRc2pEZFRIbl9uSG1kUEJrelAxVGtUSERMUGowZG5ITmRQMWJkckhUS25FWi1fYzRNSmNmLThDdFZPcGxGT1VBN09wbEJPdXlBT3NCcE91emtPc0pNT2V2OGxwQXZzWFhxbzhoNlY4eUZXWFhxbzhoZWhyQjhHcnBFTXJYWUM4WFZoU2hUQkVEUVRIREtUSFRLVEhET25XbmtuVzBkUFdOZFAxbU9ySFRMbldUS1A5N2ttZ0Y2VWduem5qbmxuZ2sxc0FkR215TzJwSEN6bjd0ZG5ha0tuRURMckh1Ym5IVDFyaWRXUHlFenNId2J1aG1WbWhOa1BCWWttMTZXUHl3V25XYmR1SDlLbkhiem4xVHpQMU52UEhtZFBXbU9QajAzUFREUXJIYzFuamNMUEhtZFBXbk9ySERMUEhtM1RFREtURURLc0VES1RFRGtuRHVqbkh3S3dCZEtQTm12c0h3andXYlZFV1Qzd0JZT3dEbVFQMUVrbmpuM25ERUtQamM4bkIzUXJIYjhuSFQxVEhUS25UREtuaWtRUEU3ZXhFRFFualRkUEVEUW5qVHpQam56VEh1NlBoRHpuV0ZCc3lGNm5XRVZQalI2UGFZT252bnpzeWMzUHlua25IbVl1QWNZUGtES1BUREtUSG5LbnprUVBXTnZzamNMbmpUS25FNzhJeVFfVEhGNnJBbVltV21rbjF1LW1XOU91V04%3D&from=Biz_list&uniqid=22f1309adc3547ad838eb242852f1f69&isauction=6&lgtid_shangyetie=6a6a222b-ba24-45a4-93c2-b85c0164db47&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FBCC3CD3B27008C907BE92A8EE583F1D9B973A8B4A94D5801EB2DA8877A329D1AF65B63FFB6F8E707E04EF8E76DCA00B4FFEC0CCE3801A2FFA4D1F9DC6EBA909B4E604EE10275804C10BB757A6F94AF636BEA110757BD6521C022F13B88476BAA24B595428D1DAFE0E499A568B0915D4BC6E5334C2B73BC9B9'},
  { size: 42, rent: 1800, name: '市場掛牌: 美院食堂 (42平方米)', url: 'https://m.anjuke.com/gz/sp/zu/7062576725/?proType=combo&legoHuiDu=0&houseid=3935806823230466&zhidingLegoHuiDu=0&from=Biz_list&uniqid=331263a26d9b4ee9a63fe9768c71f8d3&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FBF30DFD90591CC9D5D96CA39BBBA51A087F26375BBFD2DE1C802376CDE7AC1C6C8E9FDEBF015CB6772F45556766C7DE098C39DE308C4EA9F11BF0AA9D3B3B7E6D499A568B0915D4BCD0BC0AA31AC59297'},
  { size: 30, rent: 6500, name: '市場掛牌: 地鐵口旺舖 (30平方米)', url: 'https://m.anjuke.com/gz/sp/zu/7065247084/?proType=combo&legoHuiDu=0&houseid=3940202733200395&zhidingLegoHuiDu=0&from=Biz_list&uniqid=58b30f7524664820912e72a4b172e064&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FBF30DFD90591CC9D5D96CA39BBBA51A087F26375BBFD2DE1C802376CDE7AC1C6C7E502A1704EC729C499A568B0915D4BC0BCED252A19C9B4A'},
  { size: 20, rent: 780, name: '市場掛牌: 鷹爪樹街 (20平方米)', url: 'https://m.anjuke.com/gz/sp/zu/7071296879/?proType=combo&legoHuiDu=0&houseid=3949938288585731&zhidingLegoHuiDu=0&from=Biz_list&uniqid=3e596c451f2b4679bc38aa368d77fac0&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FBF30DFD90591CC9D5D96CA39BBBA51A087F26375BBFD2DE1C802376CDE7AC1C6C7E502A1704EC729C499A568B0915D4BC8A7CB2DD131C6ACF'},
  { size: 40, rent: 3500, name: '市場掛牌: 東塱大街 (40平方米)', url: 'https://m.anjuke.com/gz/sp/zu/7137406896/?proType=geren&legoHuiDu=0&houseid=4060177678228485&zhidingLegoHuiDu=0&from=Biz_list&uniqid=6b19536f7f4c4802bdf980167ece7825&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BC399D6D13AC332A64'},
  { size: 50, rent: 9980, name: '市場掛牌: 麗和華庭 (50平方米)', url: 'https://m.anjuke.com/gz/sp/zu/7120479688/?proType=geren&legoHuiDu=0&houseid=4029609969868802&zhidingLegoHuiDu=0&from=Biz_list&uniqid=6a9556fa8dbb403b80edf1ee58ab5ca5&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BC5781F04EDA97F422'},
  { size: 30, rent: 2200, name: '市場掛牌: 白鶴洞街 (30平方米)', url: 'https://m.anjuke.com/gz/sp/zu/d4062298069721093/?proType=geren&legoHuiDu=0&houseid=4062298069721093&zhidingLegoHuiDu=0&from=Biz_list&uniqid=d1d78ed153cb49f99e519a75462b6e86&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BC3A21CEE99C76B01D'},
  { size: 20, rent: 2500, name: '市場掛牌: 海南七社 (20平方米)', url: 'https://m.anjuke.com/gz/sp/zu/d4061820667812872/?proType=geren&legoHuiDu=0&houseid=4061820667812872&zhidingLegoHuiDu=0&from=Biz_list&uniqid=b4d6c25ace6243e8b5943a6a8ddc7f75&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BC99192A5BDBDFD892'},
  { size: 35, rent: 5300, name: '市場掛牌: 茶滘路建材街 (35平方米)', url: 'https://m.anjuke.com/gz/sp/zu/d4060094560739339/?proType=geren&legoHuiDu=0&houseid=4060094560739339&zhidingLegoHuiDu=0&from=Biz_list&uniqid=43d0aaada61c47a5a31012952f996c0c&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BC3FBB8334404F3CA4'},
  { size: 40, rent: 5300, name: '市場掛牌: 葵蓬茶葉市場 (40平方米)', url: 'https://m.anjuke.com/gz/sp/zu/d4054378792512525/?proType=geren&legoHuiDu=0&houseid=4054378792512525&zhidingLegoHuiDu=0&from=Biz_list&uniqid=6d214b0bc5264f0cb8cc5f0ac59b4f96&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BC140CDBA3E9244653'},
  { size: 30, rent: 3700, name: '市場掛牌: 車智升汽車改裝 (30平方米)', url: 'https://m.anjuke.com/gz/sp/zu/d3939939555385348/?proType=geren&legoHuiDu=0&houseid=3939939555385348&zhidingLegoHuiDu=0&from=Biz_list&uniqid=82b1efdde7e64da1bddd37b0293dc233&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BC99DF1735ED1E7B9C'},
  { size: 26, rent: 2300, name: '市場掛牌: 怡福花園 (26平方米)', url: 'https://m.anjuke.com/gz/sp/zu/d4048754536606721/?proType=geren&legoHuiDu=0&houseid=4048754536606721&zhidingLegoHuiDu=0&from=Biz_list&uniqid=ca151f4f71f749579b07417e7d3f8eea&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BCF35052914CAD94BB'},
  { size: 39, rent: 3500, name: '市場掛牌: 鶴翔路 (39平方米)', url: 'https://m.anjuke.com/gz/sp/zu/d4032106342227969/?proType=geren&legoHuiDu=0&houseid=4032106342227969&zhidingLegoHuiDu=0&from=Biz_list&uniqid=ab47e45684f34c59a7efbeb98b50fe20&isauction=1&urlParamsMap=B121A1EDF46CDBAA4B8F2D690AA02A602CA6739273F3467C5AAF53EB02CCD8724DB2939B74FF18FB69F137AA064C614CD55400B4715A5A9DAD3AA82BD3B92A4B8653194EDAE08D281DBCE96931D66BAB499A568B0915D4BC12C7878CBF0B2F74'},
  { size: 37.5, rent: 2050, name: '本物業 (預測)' }, // Current property
];

export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#d0ed57', '#ff8a65', '#4db6ac', '#ffb74d', '#a1887f', '#90a4ae', '#7986cb', '#e57373', '#f06292'];

export const PROPERTY_AREA_SQM = 37.5;

// Define initial default values
export const initialProjectedUnitPriceDefault = historicalPriceData[historicalPriceData.length - 1].commercialPrice;
export const initialProjectedMonthlyRentDefault = historicalPriceData[historicalPriceData.length - 1].rentalPrice;
export const initialAgentPriceDefault = 1.3; // Changed to millions
export const initialActualMonthlyRentDefault = historicalPriceData.find(d => d.year === 2024)?.rentalPrice || 0;
export const initialTaxRateDefault = 0.5; // Default tax rate (e.g., 50%)

export const IconMapping = {
  Building2,
  TrendingUp,
  TrendingDown,
  Home,
  MapPin,
  BarChart3,
  Calendar,
  DollarSign,
  Percent,
  ArrowRight,
  ArrowDown,
  ArrowUp,
  Info,
  AlertCircle,
  CheckCircle2,
  XCircle,
  HelpCircle,
  Landmark,
  Wallet,
  Calculator,
  Scale,
  Banknote,
  RotateCcw
};

// 廣州商舖/零售物業市場供求數據 (萬平方米)
export const commercialPropertyMarketData = [
  { year: 2020, supply: 48.7, transaction: 50.7, citationId: 7 }, // 商舖
  { year: 2021, supply: 40.3, transaction: 40.5, citationId: 8 }, // 商舖
  { year: 2022, supply: 105, transaction: 60, citationId: 9 },   // 零售物業 (新增供應, 淨吸納量)
  { year: 2023, supply: 65.7, transaction: 55.6, citationId: 10 },// 零售物業 (新增供應, 淨吸納量)
  { year: 2024, supply: 70, transaction: 0, citationId: 11 }     // 零售物業 (預測新增供應, 成交量 N/A)
];

export const rmbInterestRates = [
  { date: "2024-10-18", term: "一年", rate: 1.10, url: "https://www.boc.cn/fimarkets/lilv/fd31/202410/t20241018_25175416.html" },
  { date: "2024-07-25", term: "一年", rate: 1.35, url: "https://www.boc.cn/fimarkets/lilv/fd31/202407/t20240725_25118074.html" },
  { date: "2023-12-22", term: "一年", rate: 1.45, url: "https://www.boc.cn/fimarkets/lilv/fd31/202312/t20231222_24285701.html" },
  { date: "2023-09-01", term: "一年", rate: 1.55, url: "https://www.boc.cn/fimarkets/lilv/fd31/202309/t20230901_23679836.html" },
  { date: "2023-06-08", term: "一年", rate: 1.65, url: "https://www.boc.cn/fimarkets/lilv/fd31/202306/t20230608_23194241.html" },
  { date: "2022-09-15", term: "一年", rate: 1.65, url: "https://www.boc.cn/fimarkets/lilv/fd31/202209/t20220915_21788988.html" },
  { date: "2015-10-24", term: "一年", rate: 1.75, url: "https://www.boc.cn/fimarkets/lilv/fd31/201510/t20151023_5824963.html" },
  { date: "2015-08-26", term: "一年", rate: 2.00, url: "https://www.boc.cn/fimarkets/lilv/fd31/201508/t20150825_5512289.html" },
  { date: "2015-06-28", term: "一年", rate: 2.25, url: "https://www.boc.cn/fimarkets/lilv/fd31/201506/t20150627_5216867.html" },
  { date: "2015-05-11", term: "一年", rate: 2.50, url: "https://www.boc.cn/fimarkets/lilv/fd31/201505/t20150510_5002198.html" },
  { date: "2015-03-01", term: "一年", rate: 2.75, url: "https://www.boc.cn/fimarkets/lilv/fd31/201502/t20150228_4678960.html" },
  { date: "2014-11-22", term: "一年", rate: 3.00, url: "https://www.boc.cn/fimarkets/lilv/fd31/201411/t20141121_4184474.html" },
  { date: "2012-07-06", term: "一年", rate: 3.25, url: "https://www.boc.cn/fimarkets/lilv/fd31/201207/t20120705_1887040.html" },
  { date: "2012-06-08", term: "一年", rate: 3.50, url: "https://www.boc.cn/fimarkets/lilv/fd31/201206/t20120608_1846662.html" },
  { date: "2011-07-07", term: "一年", rate: 3.50, url: "https://www.boc.cn/fimarkets/lilv/fd31/201107/t20110706_1444098.html" },
  { date: "2011-04-06", term: "一年", rate: 3.25, url: "https://www.boc.cn/fimarkets/lilv/fd31/201104/t20110405_1347155.html" },
  { date: "2011-02-09", term: "一年", rate: 3.00, url: "https://www.boc.cn/fimarkets/lilv/fd31/201102/t20110208_1291781.html" },
  { date: "2010-12-26", term: "一年", rate: 2.75, url: "https://www.boc.cn/fimarkets/lilv/fd31/201012/t20101225_1247523.html" },
  { date: "2010-10-20", term: "一年", rate: 2.50, url: "https://www.boc.cn/fimarkets/lilv/fd31/201010/t20101020_1170160.html" },
  { date: "2008-12-23", term: "一年", rate: 2.25, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081222_508225.html" },
  { date: "2008-11-27", term: "一年", rate: 2.52, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499189.html" },
  { date: "2008-10-30", term: "一年", rate: 3.60, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499188.html" },
  { date: "2008-10-09", term: "一年", rate: 3.87, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499187.html" },
  { date: "2007-12-21", term: "一年", rate: 4.14, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499186.html" },
  { date: "2007-09-15", term: "一年", rate: 3.87, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499185.html" },
  { date: "2007-08-22", term: "一年", rate: 3.60, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499184.html" },
  { date: "2007-07-21", term: "一年", rate: 3.33, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499183.html" },
  { date: "2007-05-19", term: "一年", rate: 3.06, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499182.html" },
  { date: "2007-03-18", term: "一年", rate: 2.79, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499181.html" },
  { date: "2006-08-19", term: "一年", rate: 2.52, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499180.html" },
  { date: "2006-04-28", term: "一年", rate: 2.25, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499179.html" },
  { date: "2004-10-29", term: "一年", rate: 2.25, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499178.html" },
  { date: "2002-02-21", term: "一年", rate: 1.98, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499177.html" },
  { date: "1999-06-10", term: "一年", rate: 2.25, url: "https://www.boc.cn/fimarkets/lilv/fd31/200812/t20081217_499176.html" }
]; 